import { useState, useEffect } from "react";
import "./HomePage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import fantasyGif from "../../assets/play-fantasy.gif";
import registerGif from "../../assets/register.gif";
import marketTrendGif from "../../assets/market-trend.gif";
import pickStocksGif from "../../assets/pick-stocks.gif";
import bidSlotsGif from "../../assets/bid-slots.gif";
import leaderboardGif from "../../assets/leaderboard.gif";
import rightArrowWhite from '../../assets/right-arrow-white.png';
import { Helmet } from "react-helmet-async";
import SushmaAvatar from '../../assets/sushma.jpg'
import SudarshanAvatar from '../../assets/sudarshan-rao.jpg'
import KrishnaVamsiAvatar from '../../assets/krishna-vamsi.jpg'
import SrinivasYadlaAvatar from '../../assets/srinivas-yadla.jpg'
import PradeepAvatar from '../../assets/pradeep-avatar.jpg'

const HomePage = ({ scrollToContact }) => {
  const [openIndex, setOpenIndex] = useState(null);
  useEffect(() => {
    if (scrollToContact) {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [scrollToContact]);
  const faqs = [
    {
      question: "What is Fantasy Stock Predictions?",
      answer:
        "Fantasy Stocks predictions is an exciting game! Users can predict the performance of various stocks within a given timeframe, and those with the most accurate predictions can win real cash prizes.",
    },
    {
      question: "Is it possible to win real cash prizes in Nifty 10?",
      answer:
        "Certainly! We offer a range of cash contests, each featuring different slots entry, entry fees, and prize pools. Select a fantasy stocks prediction that suits your preference and aim to outperform your competitors for the chance to celebrate big victories!",
    },
    {
      question: "How secure is it to add funds into Nifty 10?",
      answer:
        "Money filling to your Nifty10 account is an easy and secure process. We’ve authorized a wide range of payment methods on Nifty10 to guarantee the security of your personal information.\nOnce your personal information has been verified, you can take your winnings from Nifty10 straight to your bank account.",
    },
    {
  question: "How long does it take for Nifty 10 to credit the winnings?",
  answer: "Winnings are typically credited within 3 working days after a successful withdrawal request.",
},
    {
      question: "How should I download the Nifty10 Android app?",
      answer:
        "There are multiple ways in which you can download the Nifty10 app. Choose what’s best for you! \n👉 Head to www.Nifty10.com on your desktop or mobile browser and enter your ‘mobile number’ to get the download link. \n👉 As an Android user, you can also download the Nifty10 app from the Google Play Store.",
    },
    {
      question: "What type of contests are available for participation?",
      answer:
        "Select the market trend, and pick your choice of preference contents slot and join by paying the entry amount.",
    },
    {
      question: "How to play Nifty 10?",
      answer:
        "Step 1: Login with Mobile number to register on Nifty10 App \nStep2: Select the market trend \nStep3: Pick up your choice of FIVE stocks and proceed to Bids slots \nStep4: Select your choice of bid slots and pay entry fee and join the contests \nStep5: Check the real time leaderboard for the winners",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
document.addEventListener('DOMContentLoaded', () => {
  const testimonialScroll = document.querySelector('.testimonial-scroll');
  if (!testimonialScroll) return;

  let scrollAmount = 0;
  const scrollStep = 1;
  const scrollDelay = 10;

  function autoScrollTestimonials() {
    scrollAmount += scrollStep;

    if (scrollAmount >= testimonialScroll.scrollWidth - testimonialScroll.clientWidth) {
      scrollAmount = 0;
    }

    testimonialScroll.scrollLeft = scrollAmount;
  }

  setInterval(autoScrollTestimonials, scrollDelay);
});


  return (
    <>
    <Helmet>
        <title>Nifty10 | Play Stock Prediction & Win</title>
        <meta
          name="description"
          content="Join Nifty10 and play stock market prediction games daily. Predict market movements, compete with others, and win exciting prizes!"
        />
      </Helmet>
      {/* Fantasy Section */}
      <section className="fantasy-section">
        <div className="content">
          <img src={fantasyGif} alt="Stock Icon" className="icon" />
          <h2>
            Play Fantasy Stocks on <span>Nifty10</span> and Win Real prizes!
          </h2>
          <p className="description">
            Fantasy Stocks prediction is an exciting game! Users can predict the
            performance of various stocks within a given timeframe, and those
            with the most accurate predictions can win <strong>real prizes</strong>.
          </p>
          <p className="description">
            It's a fun way to test your knowledge of the market trend and see
            how well you can predict stock movements.
          </p>
          {/* <p className="note">
  <img
    src="https://assets-v2.lottiefiles.com/a/d7221d6a-1178-11ee-8dbb-fb2a7df45d05/WTtB4ellJh.gif"
    alt="Investment Alert"
    style={{ width: '40px', verticalAlign: 'middle', marginRight: '6px' }}
  />
  Always invest responsibly and do your research before making any financial decisions.
</p> */}

        </div>
      </section>

      {/* Steps to Play Section */}
      <section id="steps-to-play" className="steps-to-play section-padding">
        <div className="container">
          <h2 className="section-title steps-title">Steps to Play</h2>
          <div className="cards-container">
            <div className="card card-design">
              <div className="icon-wrapper">
                <img src={registerGif} alt="Register Icon" />
              </div>
              <h3>Register</h3>
              <p>Sign up with your mobile number.</p>
              <div className="card__ribbon">
                          <label className="card__ribbon-label">01</label>
                      </div>
            </div>

            <div className="card card-design">
              <div className="icon-wrapper">
                <img src={marketTrendGif} alt="Select Market Trend Icon" />
              </div>
              <h3>Select Market Trend</h3>
              <p>Choose your prediction for the market.</p>
                            <div className="card__ribbon">
                          <label className="card__ribbon-label">02</label>
                      </div>
            </div>

            <div className="card card-design">
              <div className="icon-wrapper">
                <img src={pickStocksGif} alt="Pick Stocks Icon" />
              </div>
              <h3>Pick Stocks</h3>
              <p>Select 5 stocks to create your team.</p>
                            <div className="card__ribbon">
                          <label className="card__ribbon-label">03</label>
                      </div>
            </div>

            <div className="card card-design">
              <div className="icon-wrapper">
                <img src={bidSlotsGif} alt="Choose Bid Slot Icon" />
              </div>
              <h3>Choose Slot</h3>
              <p>Select your free entry and join contests.</p>
                            <div className="card__ribbon">
                          <label className="card__ribbon-label">04</label>
                      </div>
            </div>

            <div className="card card-design">
              <div className="icon-wrapper">
                <img src={leaderboardGif} alt="Track Performance Icon" />
              </div>
              <h3>Track Performance</h3>
              <p>Monitor real-time leaderboard and win prizes.</p>
                            <div className="card__ribbon">
                          <label className="card__ribbon-label">05</label>
                      </div>
            </div>
          </div>
        </div>
      </section>
      {/* Steps to Play Section Video */}
      <section id="steps-to-play" className="steps-to-play">
        <div className="container">
          <h2 className="section-title">How to Play</h2>
          <p className="description">
            It's a fun way to test your knowledge of the market trend and see how well you can predict stock movements.
          </p>
          {/* Responsive YouTube Video */}

          <div className="responsive-video">
            {/* <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/t2QJgJ27fF0?si=PHB5ojXXiDMHw5z2" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}
          <iframe width="560" height="315" src="https://www.youtube.com/embed/i4SMEaGDNq0?si=rIX0lJ-Vx2M4V8D9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>

        </div>
      </section>
      {/* Testimonials Section */}
<section className="testimonials section-padding">
  <div className="container">
    <h2 className="section-title testimonial-title">Testimonials</h2>
    <h2 className="testimonial-subtitle">What our winners speak</h2>

    <div className="testimonial-scroll">
      <div className="testimonial-cards">
        <div className="testimonial-card">
          <img src={PradeepAvatar} alt="Pradeep" className="user-image" />
          <p>“Nifty10 is an amazing platform that combines financial markets with fantasy gaming seamlessly.”</p>
          <span className="author">– Pradeep</span>
          <div className="rating">★★★★★</div>
        </div>

        <div className="testimonial-card">
          <img src={SushmaAvatar} alt="Sushma" className="user-image" />
          <p>“A refreshing twist on stock market fantasy games that is engaging and rewarding.”</p>
          <span className="author">– Sushma</span>
          <div className="rating">★★★★★</div>
        </div>

        <div className="testimonial-card">
          <img src={SrinivasYadlaAvatar} alt="Srinivas Yadla" className="user-image" />
          <p>“It helped me hone my investment skills while having fun competing with others.”</p>
          <span className="author">– Srinivas Yadla</span>
          <div className="rating">★★★★★</div>
        </div>

        <div className="testimonial-card">
          <img src={KrishnaVamsiAvatar} alt="Krishna Vamsi" className="user-image" />
          <p>“I really like Nifty10 fantasy game app! As a beginner to the stock market, it's super easy to use and user-friendly. It helped me understand the basics of investing.”</p>
          <span className="author">– Krishna Vamsi</span>
          <div className="rating">★★★★★</div>
        </div>

        <div className="testimonial-card">
          <img src={SudarshanAvatar} alt="Sudharshan Rao" className="user-image" />
          <p>“Nifty10 is a fantastic app for anyone who enjoys predicting stock trends! The concept of placing bids on bullish or bearish movements is both exciting and educational.”</p>
          <span className="author">– Sudarshan Rao</span>
          <div className="rating">★★★★★</div>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* FAQs Section */}
      {/* <section id="faqs" className="faqs section-padding">
        <div className="container">
  <h2>Frequently Asked Questions</h2>
  {faqs.map((faq, index) => {
    const isOpen = openIndex === index;
    return (
      <div className={`faq-item ${isOpen ? "open" : ""}`} key={index}>
        <button
          className="faq-question"
          onMouseEnter={() => toggleFAQ(index)}
          aria-expanded={isOpen}
        >
          {faq.question}
          <FontAwesomeIcon
            icon={faChevronDown}
            className={isOpen ? "rotated" : ""}
          />
        </button>
        <div
          className="faq-answer"
          style={{
            maxHeight: isOpen ? "500px" : "0",
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>{faq.answer}</p>
        </div>
      </div>
    );
  })}
</div>

      </section> */}

      {/* Contact Section */}
      <section id="contact" className="contact section-padding">
        <div className="container">
          <h2>Contact Us</h2>
          <div
            id="contact"
            className="contact-container"
          >
            <h2 className="contact-heading">Get in Touch</h2>
            <p className="contact-description">
              I'd love to hear from you! If you have any questions, comments, or feedback, please use the form below.
            </p>

            <form
              method="POST"
              action="https://api.web3forms.com/submit"
              className="contact-form"
              name="contactForm"
            >
              <input
                type="hidden"
                name="access_key"
                value="fa9a666b-e0aa-4c98-a218-c953512c9c25"
              />

              <div className="contact-input-group">
                <input
                  name="name"
                  type="text"
                  placeholder="Enter your Name"
                  className="contact-input"
                  required
                />
                <input
                  name="email"
                  type="email"
                  placeholder="Enter your Email"
                  className="contact-input"
                  required
                />
              </div>

              <textarea
                name="message"
                rows="6"
                placeholder="Enter your Message"
                className="contact-textarea"
                required
              ></textarea>

              <button
                type="submit"
                className="contact-submit-button"
              >
                Submit now
                <img src={rightArrowWhite} alt="right arrow icon" className="contact-arrow-icon" />
              </button>
            </form>
          </div>
          <div className="contact-info">
            <div className="testimonial-card">
              <h3>Corporate Office</h3>
              <p>
                #709, Gowra Fountain Head, HUDA Techno Enclave, Mindspace Rd,
                HITEC City, Hyderabad, Telangana 500081
              </p>
            </div>
            <div className="testimonial-card">
              <h3>Registered Office</h3>
              <p>
                8-3-231/A/278 & 279, Flat No. 404, Sri Krishna Nagar,
                Yousufguda, Khairatabad, Hyderabad – 500045, Telangana
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
